import { Constants } from '@arrived/common';
import { AvailabilityFilter, OfferingSearchQuery } from '@arrived/models';

import { useIsOfferingInSet } from './useIsOfferingInSet';

const query: OfferingSearchQuery = {
  availability: { eq: [AvailabilityFilter.FOR_SALE] },
  isEarlyAccess: { eq: [false] },
  size: Constants.numberOfTrendingOfferings,
  sort: 'propertyRank:desc,id:desc',
};

// TODO: This hook really shouldn't live in /queries, it just made the most sense for this refactor to place it here
//  for now.
export function useIsOfferingTrending() {
  return useIsOfferingInSet(query);
}
